// utils/apiClient.js
import axios from "axios";
import { showError, showSuccess } from "./toastUtils";
import { decryptData, encryptData } from "../crypto";

const baseURL = process.env.REACT_APP_API_BASE_URL;

const api = axios.create({
  baseURL: baseURL,
});

api.interceptors.request.use(
  (config) => {
    const encryptedToken = sessionStorage.getItem("token");
    if (encryptedToken) {
      const token = decryptData(encryptedToken);
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const errorMsg = error.response?.data?.message;

    // 🔄 Handle Token Refresh
    if (errorMsg === "jwt expired" && !originalRequest._retry && !originalRequest.url?.includes("/v1/b2b/client/auth/re_login")) {
      originalRequest._retry = true;
      try {
        const encryptedRefreshToken = sessionStorage.getItem("refresh_token");
        const refreshToken = decryptData(encryptedRefreshToken);

        if (refreshToken) {
          const res = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/client/auth/re_login`,
            {
              headers: { "x-refreshtoken": refreshToken },
            }
          );

          if (res.data.success) {
            const newToken = res.data.token;
            const newRefreshToken = res.data.refresh_token;

            sessionStorage.setItem("token", encryptData(newToken));
            if (newRefreshToken) {
              sessionStorage.setItem("refresh_token", encryptData(newRefreshToken));
            }

            // Update Header and Retry Original Request
            originalRequest.headers.Authorization = `Bearer ${newToken}`;
            return api(originalRequest);
          }
        }
      } catch (err) {
        console.error("Token refresh failed:", err);
      }
    }

    if (
      errorMsg === "Invalid or expired token. Please refresh your session." ||
      errorMsg === "You are logged out. Please log in again." ||
      errorMsg === "Session expired. Please log in again."||
      errorMsg === "jwt expired" ||
      errorMsg === "No auth token"||
      errorMsg === "Invalid or expired token. Please log in again."
    ) {
      window.dispatchEvent(new CustomEvent("session-expired"));
    }
    return Promise.reject(error);
  }
);

export const apiClient = async (method, url, data, showToast = true) => {
  try {
    const response = await api.request({
      method,
      url,
      data,
    });

    // Optional: show success toast
    // if (showToast) {
    //   showSuccess(response?.data?.message || "Success");
    // }

    return response.data;
  } catch (error) {
    const errMsg =
      error.response?.data?.message || error.message || "Something went wrong";

    if (showToast) {
      showError(errMsg);
    }

    throw error;
  }
};
